import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import { Transition } from '@headlessui/react'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'

const OrderActionsButton = ({ id }) => {
  const [actions, setActions] = useState([])
  const [showActions, setShowActions] = useState(false)
  const { formatMessage } = useIntl()

  const onShowActions = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setShowActions(!showActions)
  }

  useEffect(() => {
    if (!showActions || actions.length) {
      return
    }

    fetch(`/rest/v2/order/${id}/actions`, {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then((response) => response.json())
      .then(({ success, data, meta, errors }) => {
        if (errors) {
          return window.alert(errors.join(', '))
        }

        setActions(data.map((action) => ({ ...action, meta: { ...action.meta, ...meta } })))
      })
      .catch((error) => window.alert(error))
  }, [id, showActions])

  return (
    <div className="relative">
      <div>
        <button
          onBlur={() => setShowActions(false)}
          onClick={onShowActions}
          className="z-0 w-8 h-8 flex justify-center items-center rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-darker z-0"
          id="user-menu"
          aria-haspopup="true"
          title={formatMessage(messages.actionsMenu)}
        >
          <span className="sr-only"><FormattedMessage{...messages.actionsMenu}/></span>
          <Icon icon="ellipsis-v" />
        </button>
      </div>

      <Transition
        show={showActions}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
        className="z-50 origin-top-right absolute right-0 mt-2 w-48 rounded-sm shadow-md bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 overflow-hidden z-10"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="user-menu"
      >
        <Link
          to={`/orders/${id}`}
          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          role="menuitem"
          onMouseDown={(event) => event.preventDefault()}
        >
          <FormattedMessage {...messages.view} />
        </Link>

        <Link
          to={`/orders/${id}`}
          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          role="menuitem"
          onMouseDown={(event) => event.preventDefault()}
        >
          <FormattedMessage {...messages.edit} />
        </Link>

        <Link
          to={`/orders/${id}/duplicate`}
          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          role="menuitem"
          onMouseDown={(event) => event.preventDefault()}
        >
          <FormattedMessage {...messages.duplicate} />
        </Link>

        { actions.map((action, i) => (
          <Link
            key={`action-${i}`}
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 z-50"
            role="menuitem"
            onMouseDown={(event) => event.preventDefault()}
            to={{
              pathname: `/orders/new/${action.meta.hashId}`,
              state: action,
            }}
          >
            { action.meta.name }
          </Link>
        )) }

        <Link to="/docs/cancel-order" className="block px-4 py-2 text-sm text-red-700 bg-red-100 hover:bg-gray-100" role="menuitem" onMouseDown={(event) => event.preventDefault()}><FormattedMessage{...messages.cancel}/></Link>
      </Transition>
    </div>
  )
}

export default OrderActionsButton
